<template>
  <template v-if="contentStore.select_componentlist != null">
    <v-menu 
      v-model="dialog_com"
      location="start"
      :close-on-content-click="false"
      @update:modelValue="menu_handler"
      >

      <template v-slot:activator="{ props }">
        <div v-bind="props" style="cursor:pointer" class="d-flex justify-center">
          <div style="width:25px;height:25px;border:1px gray solid"
              :style="{ background : value }"
              />
        </div>
      </template>

      <v-card class="ma-0 pa-1">
        <v-row dense align="center" class="pa-0 ma-0">
          <v-col cols="9" class="ml-5 mt-2">
            <label style="color:black">{{title}}</label>
          </v-col>
          <v-col cols="2" class="mt-2">
            <v-btn size="small" class="dialog_close_btn mr-1" @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row dense justify="center" class="pa-0 ma-0">
          <v-col cols="11">
            <div style="background:gray;height:1px;" />
          </v-col>
        </v-row>

        <v-card-text>
          <v-container>
            <v-row justify="center">
              <!-- Vue3ColorPicker가 문제있다면 기본 HTML input 사용 -->
              <template v-if="useBasicPicker">
                <input 
                  type="color" 
                  v-model="currentColor" 
                  @input="handleColorChange"
                  style="width: 100%; height: 150px; border: none; cursor: pointer;"
                />
                
                <v-text-field
                  v-model="currentColor"
                  label="색상 코드"
                  @input="handleColorChange"
                  style="margin-top: 10px;"
                  />
              </template>
              
              <!-- Vue3ColorPicker 사용 -->
              <template v-else>
                <Vue3ColorPicker style="width: 270px;" class="elevation-0"
                  v-model="currentColor" 
                  mode="solid" 
                  show-eye-drop="true" show-input-menu="true"
                  @update:modelValue="handleColorChange" 
                  />
              </template>
            </v-row>
          </v-container>
        </v-card-text> 

        <v-row dense justify="center" class="pa-0 ma-0">
          <v-col cols="11">
            <div style="background:gray;height:1px;" />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-row justify="center">
          <v-btn size="small" @click="close_com">취소</v-btn>
          <v-btn size="small" class="ml-5" @click="save_com">선택</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-menu>
  </template>
</template>

<script>

import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker';
import '@cyhnkckali/vue3-color-picker/dist/style.css'
import { useContentStore } from "@/stores/content";

export default {

  components:{
    // Vue3ColorPicker가 사용 가능할 때만 등록
    ...(typeof Vue3ColorPicker !== 'undefined' ? { Vue3ColorPicker } : {})
  },

  props:{
    value: {
      type: String,
      required: true
    },
    title:{
      type:String,
      default(){
        return "";
      }
    },
  },

  emits: ['change'],

  setup(){
    const contentStore = useContentStore();
    return {contentStore};
  },

  computed: {
    // Vue3ColorPicker 사용 가능 여부 확인
    useBasicPicker() {
      return typeof Vue3ColorPicker === 'undefined';
    }
  },

  data: ()=> ({
    dialog_com : false,
    disabled:false,
    color_backup:"",
    currentColor: "",
  }),

  methods: {

    handleColorChange() {
      // 실시간 색상 변경 (미리보기용)
      //console.log('Background color changed:', this.currentColor);
    },

    //다이얼로그 닫기
    close_com () {
      this.currentColor = this.color_backup;
      this.dialog_com = false
    },

    //추가 저장
    save_com () {
      this.$emit('change', this.currentColor);
      this.dialog_com = false
    },      

    menu_handler(){
      //최초 또는 메뉴 외곽 클릭시 
      //색상값 백업
      this.color_backup = this.value;
      this.currentColor = this.value;
    },
  }
}
</script>

<style scoped>
</style>